import { TextField } from '@mui/material';
import { FC } from 'react';

import SearchAdornment from '@uiKit/SearchAdorment';

interface UserSearchFieldProps {
  search: string;
  handleSearchChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const UserSearchField: FC<UserSearchFieldProps> = ({ search, handleSearchChange }) => {
  return (
    <TextField
      value={search}
      onChange={handleSearchChange}
      placeholder="Search"
      sx={{ m: 2.5 }}
      InputProps={{
        startAdornment: <SearchAdornment />,
      }}
    />
  );
};

export default UserSearchField;
